import { render } from "./InsuranceList.vue?vue&type=template&id=4c858e98&scoped=true"
import script from "./InsuranceList.vue?vue&type=script&lang=js"
export * from "./InsuranceList.vue?vue&type=script&lang=js"

import "./InsuranceList.vue?vue&type=style&index=0&id=4c858e98&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c858e98"]])

export default __exports__